
import { images } from "../constants";
import cars from "./cars";

const dealers = [
    {
        id: 1,
        image: images.dealer1,
        title: "Global Motors",
        location: "Main Street, Downtown",
        phone: "(123) 456-7890",
        inventory: cars.filter(car => car.dealerId === 1), // Fetch only dealer's cars
        details: {
            number: "(123) 456-7890",
            email: "sales@globalmotors.com",
            website: "www.globalmotors.com",
            location: "Main Street, Downtown",
            price: "$15,000 - $90,000",
            listings: `${cars.filter(car => car.dealerId === 1).length} listings`, // Count of cars for the dealer
            availability: "Brand-new and certified pre-owned cars",
            specialties: "Luxury, electric, and high-performance vehicles",
            reviews: "Rated 4.9/5 by 300+ customers",
            hours: "Mon - Sat: 9 AM - 7 PM"
        },
        overviews: [
            "Global Motors is a leading automotive dealership, offering a vast selection of top-quality vehicles. Whether you're searching for luxury, electric, or family-friendly cars, we provide an exceptional buying experience with expert guidance and unbeatable deals."
        ],
        services: [
            "Wide range of new and pre-owned vehicles.",
            "Easy financing and leasing options.",
            "Comprehensive trade-in assistance.",
            "Certified vehicle inspections and warranties.",
            "Dedicated after-sales support and maintenance."
        ],
        faqs: [
            {
                id: 1,
                heading: "What are my financing options?",
                content: "We offer multiple financing plans, including low-interest auto loans and flexible lease terms to suit your budget."
            },
            {
                id: 2,
                heading: "Are all used cars inspected?",
                content: "Yes, all our certified pre-owned vehicles go through a rigorous multi-point inspection for quality assurance."
            },
            {
                id: 3,
                heading: "Can I schedule a test drive?",
                content: "Of course! You can book a test drive online or visit our showroom to experience your preferred vehicle firsthand."
            },
            {
                id: 4,
                heading: "Do you offer vehicle trade-ins?",
                content: "Yes! Bring your current car for a free valuation, and we’ll offer you a competitive trade-in deal."
            }
        ],
        reviews: [
            {
                id: 1,
                image: images.dealer1Review1,
                name: "Michael Anderson",
                date: "November 5, 2024",
                rating: 5,
                content: "Amazing experience! Found my perfect car at a great price, and the team was super helpful throughout the process."
            },
            {
                id: 2,
                image: images.dealer1Review2,
                name: "Emily Johnson",
                date: "November 8, 2024",
                rating: 4.9,
                content: "Smooth and hassle-free buying process. Highly recommend Global Motors for their excellent service!"
            }
        ],
    
        map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3023.745632503296!2d-74.00597268459362!3d40.71277617932966!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25a3168729e03%3A0x6d0a0b2b15e364df!2sMain%20Showroom%2C%20New%20York!5e0!3m2!1sen!2sus!4v1645287442276!5m2!1sen!2sus"
    },
    
    {
        id: 2,
        image: images.dealer2,
        title: "Prestige Wheels",
        location: "Prestige City",
        phone: "(234) 567-8901",
        inventory: cars.filter(car => car.dealerId === 2), // Fetch only dealer's cars
    
        details: {
            number: "(234) 567-8901",
            email: "sales@prestigewheels.com",
            website: "www.prestigewheels.com",
            location: "Prestige City",
            price: "$20,000 - $120,000",
            listings: `${cars.filter(car => car.dealerId === 2).length} listings`, // Count of cars for the dealer
            availability: "Exclusive luxury and premium vehicles",
            specialties: "Exotic, sports, and luxury cars",
            reviews: "Rated 4.8/5 by 250+ customers",
            hours: "Mon - Sun: 10 AM - 8 PM"
        },
    
        overviews: [
            "Prestige Wheels is your go-to destination for high-end, exotic, and premium vehicles. With an elite selection of luxury cars, we provide personalized service and an unmatched buying experience."
        ],
    
        services: [
            "Exclusive selection of luxury and exotic cars.",
            "Personalized financing and leasing options.",
            "Trade-in and upgrade assistance.",
            "Certified inspections and extended warranties.",
            "VIP concierge services for elite customers."
        ],
    
        faqs: [
            {
                id: 1,
                heading: "What types of luxury cars do you offer?",
                content: "We specialize in high-end vehicles, including sports cars, exotic brands, and premium sedans."
            },
            {
                id: 2,
                heading: "Do you provide international shipping?",
                content: "Yes, we offer worldwide vehicle shipping with secure transportation options."
            },
            {
                id: 3,
                heading: "Can I get a custom order?",
                content: "Absolutely! We can help you source and import your dream car upon request."
            },
            {
                id: 4,
                heading: "Do you offer test drives for all vehicles?",
                content: "Test drives are available by appointment for select vehicles."
            }
        ],
    
        reviews: [
            {
                id: 1,
                image: images.dealer2Review1,
                name: "Sophia Martinez",
                date: "November 10, 2024",
                rating: 4.8,
                content: "Incredible selection and top-tier service. I found my dream car and the process was smooth!"
            },
            {
                id: 2,
                image: images.dealer2Review2,
                name: "James Peterson",
                date: "November 12, 2024",
                rating: 4.9,
                content: "A fantastic experience from start to finish! Highly recommended for luxury car buyers."
            }
        ],
    
        map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3023.745632503296!2d-74.00597268459362!3d40.71277617932966!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25a3168729e03%3A0x6d0a0b2b15e364df!2sMain%20Showroom%2C%20New%20York!5e0!3m2!1sen!2sus!4v1645287442276!5m2!1sen!2sus"
    },

    {
        id: 3,
        image: images.dealer3, // Dealer-Logo
        title: "Summit Cars",
        location: "Summit Hills",
        phone: "(345) 678-9012",
        inventory: cars.filter(car => car.dealerId === 3), // Fetch only dealer's cars
    
        details: {
            number: "(345) 678-9012",
            email: "sales@summitcars.com",
            website: "www.summitcars.com",
            location: "Summit Hills",
            price: "$18,000 - $80,000",
            listings: `${cars.filter(car => car.dealerId === 3).length} listings`, // Count of cars for the dealer
            availability: "New, certified pre-owned, and budget-friendly cars",
            specialties: "SUVs, family sedans, and hybrid vehicles",
            reviews: "Rated 4.7/5 by 180+ customers",
            hours: "Mon - Sat: 9 AM - 6 PM"
        },
    
        overviews: [
            "Summit Cars is dedicated to providing quality vehicles at competitive prices. Whether you're looking for a family SUV, a fuel-efficient hybrid, or a reliable sedan, we have options for every budget."
        ],
    
        services: [
            "Large selection of SUVs, hybrids, and family cars.",
            "Flexible financing plans and trade-in options.",
            "Certified vehicle inspections and extended warranties.",
            "Affordable leasing options for all budgets.",
            "Friendly and professional customer service."
        ],
    
        faqs: [
            {
                id: 1,
                heading: "Do you offer financing assistance?",
                content: "Yes! We provide flexible auto loan and leasing options to make purchasing easier."
            },
            {
                id: 2,
                heading: "Can I trade in my current vehicle?",
                content: "Absolutely! Bring your car for an evaluation, and we’ll offer a fair trade-in value."
            },
            {
                id: 3,
                heading: "Do you offer hybrid and fuel-efficient cars?",
                content: "Yes, we have a variety of hybrid and eco-friendly vehicles available."
            },
            {
                id: 4,
                heading: "Are your used cars inspected?",
                content: "Yes, all our certified pre-owned cars go through a detailed multi-point inspection."
            }
        ],
    
        reviews: [
            {
                id: 1,
                image: images.dealer3Review1,
                name: "Daniel Carter",
                date: "November 15, 2024",
                rating: 4.7,
                content: "Great selection and friendly service. The buying process was smooth, and I got a great deal!"
            },
            {
                id: 2,
                image: images.dealer3Review2,
                name: "Jessica Lee",
                date: "November 18, 2024",
                rating: 4.8,
                content: "Summit Cars helped me find the perfect hybrid for my daily commute. Highly recommend!"
            }
        ],
    
        map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3023.745632503296!2d-74.00597268459362!3d40.71277617932966!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25a3168729e03%3A0x6d0a0b2b15e364df!2sMain%20Showroom%2C%20New%20York!5e0!3m2!1sen!2sus!4v1645287442276!5m2!1sen!2sus"
    },

    {
        id: 4,
        image: images.dealer4, // Dealer-Logo
        title: "Pinnacle Auto",
        location: "Pinnacle Avenue",
        phone: "(456) 789-0123",
        inventory: cars.filter(car => car.dealerId === 4), // Fetch only dealer's cars
    
        details: {
            number: "(456) 789-0123",
            email: "sales@pinnacleauto.com",
            website: "www.pinnacleauto.com",
            location: "Pinnacle Avenue",
            price: "$20,000 - $100,000",
            listings: `${cars.filter(car => car.dealerId === 4).length} listings`, // Count of cars for the dealer
            availability: "Luxury, performance, and certified used vehicles",
            specialties: "Sports cars, executive sedans, and SUVs",
            reviews: "Rated 4.8/5 by 250+ customers",
            hours: "Mon - Sat: 10 AM - 8 PM"
        },
    
        overviews: [
            "Pinnacle Auto is the premier destination for luxury and high-performance vehicles. We offer an exclusive selection of top-tier cars, providing a seamless purchasing experience with tailored financing options."
        ],
    
        services: [
            "Luxury and performance vehicle sales.",
            "Exclusive financing and lease options.",
            "Premium trade-in valuations.",
            "Certified vehicle inspections and extended warranties.",
            "VIP customer service experience."
        ],
    
        faqs: [
            {
                id: 1,
                heading: "What luxury brands do you offer?",
                content: "We specialize in brands like BMW, Mercedes-Benz, Audi, Porsche, and more."
            },
            {
                id: 2,
                heading: "Can I test drive high-performance vehicles?",
                content: "Yes, test drives are available by appointment for eligible buyers."
            },
            {
                id: 3,
                heading: "Do you offer financing for luxury cars?",
                content: "Absolutely! We provide flexible financing plans tailored to your needs."
            },
            {
                id: 4,
                heading: "Are certified pre-owned vehicles available?",
                content: "Yes, we have a selection of certified pre-owned cars that undergo rigorous inspections."
            }
        ],
    
        reviews: [
            {
                id: 1,
                image: images.dealer4Review1,
                name: "James Robertson",
                date: "November 22, 2024",
                rating: 4.9,
                content: "The best dealership for luxury cars! Found my dream Porsche here, and the experience was flawless."
            },
            {
                id: 2,
                image: images.dealer4Review2,
                name: "Sophia Martinez",
                date: "November 25, 2024",
                rating: 4.8,
                content: "Professional service and an amazing selection of high-end vehicles. Highly recommended!"
            }
        ],
    
        map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3023.745632503296!2d-74.00597268459362!3d40.71277617932966!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25a3168729e03%3A0x6d0a0b2b15e364df!2sMain%20Showroom%2C%20New%20York!5e0!3m2!1sen!2sus!4v1645287442276!5m2!1sen!2sus"
    },

    {
        id: 5,
        image: images.dealer5, // Dealer-Logo
        title: "Crossroad Cars",
        location: "Crossroad Plaza",
        phone: "(567) 890-1234",
        inventory: cars.filter(car => car.dealerId === 5), // Fetch only dealer's cars
    
        details: {
            number: "(567) 890-1234",
            email: "sales@crossroadcars.com",
            website: "www.crossroadcars.com",
            location: "Crossroad Plaza",
            price: "$10,000 - $80,000",
            listings: `${cars.filter(car => car.dealerId === 5).length} listings`, // Count of cars for the dealer
            availability: "New, used, and certified vehicles",
            specialties: "Family-friendly SUVs, sedans, and hybrid cars",
            reviews: "Rated 4.7/5 by 200+ customers",
            hours: "Mon - Sat: 8 AM - 6 PM"
        },
    
        overviews: [
            "Crossroad Cars offers a diverse selection of high-quality vehicles, from reliable family sedans to fuel-efficient hybrids. Our expert team ensures a smooth car-buying experience with flexible financing options."
        ],
    
        services: [
            "Affordable new and pre-owned vehicles.",
            "Financing assistance with competitive rates.",
            "Hassle-free trade-in process.",
            "Certified pre-owned inspections and extended warranties.",
            "Dedicated customer support and service center."
        ],
    
        faqs: [
            {
                id: 1,
                heading: "Do you offer financing options?",
                content: "Yes, we provide various financing plans with low-interest rates and flexible payment terms."
            },
            {
                id: 2,
                heading: "Can I trade in my old car?",
                content: "Absolutely! Bring your vehicle for a free appraisal and get a great trade-in offer."
            },
            {
                id: 3,
                heading: "Are hybrid and electric cars available?",
                content: "Yes, we have a selection of fuel-efficient hybrid and electric vehicles."
            },
            {
                id: 4,
                heading: "Do you offer warranties on used cars?",
                content: "Yes, our certified pre-owned vehicles come with extended warranty options."
            }
        ],
    
        reviews: [
            {
                id: 1,
                image: images.dealer5Review1,
                name: "Daniel Cooper",
                date: "November 28, 2024",
                rating: 4.7,
                content: "Great selection of family cars at fair prices. The team was helpful and made the process easy!"
            },
            {
                id: 2,
                image: images.dealer5Review2,
                name: "Olivia Harris",
                date: "November 30, 2024",
                rating: 4.6,
                content: "Bought my first hybrid car here, and I love it! The financing options were great, and the staff was very supportive."
            }
        ],
    
        map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3023.745632503296!2d-74.00597268459362!3d40.71277617932966!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25a3168729e03%3A0x6d0a0b2b15e364df!2sMain%20Showroom%2C%20New%20York!5e0!3m2!1sen!2sus!4v1645287442276!5m2!1sen!2sus"
    },
    
    {
        id: 6,
        image: images.dealer6, // Dealer-Logo
        title: "Nextgen Autos",
        location: "Nextgen Boulevard",
        phone: "(678) 901-2345",
        inventory: cars.filter(car => car.dealerId === 6), // Fetch only dealer's cars
    
        details: {
            number: "(678) 901-2345",
            email: "sales@nextgenautos.com",
            website: "www.nextgenautos.com",
            location: "Nextgen Boulevard",
            price: "$12,000 - $85,000",
            listings: `${cars.filter(car => car.dealerId === 6).length} listings`, // Count of cars for the dealer
            availability: "Latest models, electric vehicles, and certified pre-owned cars",
            specialties: "Innovative technology, self-driving, and eco-friendly vehicles",
            reviews: "Rated 4.8/5 by 250+ customers",
            hours: "Mon - Sat: 9 AM - 8 PM"
        },
    
        overviews: [
            "Nextgen Autos is at the forefront of automotive innovation, offering a wide selection of high-tech and eco-friendly vehicles. From self-driving cars to the latest electric models, we make the future of driving accessible today."
        ],
    
        services: [
            "Top-tier selection of smart and electric vehicles.",
            "Flexible financing plans with low APR options.",
            "Seamless online car browsing and purchasing.",
            "Trade-in deals for upgrading to the latest models.",
            "Exclusive warranties and maintenance packages."
        ],
    
        faqs: [
            {
                id: 1,
                heading: "Do you sell self-driving cars?",
                content: "Yes! We have the latest autonomous and semi-autonomous vehicles in stock."
            },
            {
                id: 2,
                heading: "Can I apply for financing online?",
                content: "Absolutely! Our website allows you to apply for financing and get pre-approved in minutes."
            },
            {
                id: 3,
                heading: "Are there any government incentives for EVs?",
                content: "Yes, we help you navigate tax credits and incentives available for electric vehicle purchases."
            },
            {
                id: 4,
                heading: "Do you offer home delivery?",
                content: "Yes, we provide a contactless home delivery service for your convenience."
            }
        ],
    
        reviews: [
            {
                id: 1,
                image: images.dealer6Review1,
                name: "Sophia Martinez",
                date: "December 3, 2024",
                rating: 4.9,
                content: "A seamless buying experience! I got my dream electric car with amazing financing options."
            },
            {
                id: 2,
                image: images.dealer6Review2,
                name: "James Carter",
                date: "December 5, 2024",
                rating: 4.8,
                content: "Incredible selection of tech-packed vehicles. Their customer service was top-notch!"
            }
        ],
    
        map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3023.745632503296!2d-74.00597268459362!3d40.71277617932966!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25a3168729e03%3A0x6d0a0b2b15e364df!2sMain%20Showroom%2C%20New%20York!5e0!3m2!1sen!2sus!4v1645287442276!5m2!1sen!2sus"
    }

];

export default dealers;
